import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';

import { SvgService } from './svg.service';

@Component({
  selector: 'app-flag',
  template: '<ng-content></ng-content>',
  providers: [SvgService]
})
export class FlagComponent implements OnInit, OnChanges {
  @Input() name!: string;
  @Input() fontSize?: number | string;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private svgService: SvgService
  ) {}

  ngOnInit(): void {
    this.element.nativeElement.innerHTML = '';
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      this.svgService.loadFlag(this.name).subscribe(svg => this.setSvg(svg));
    }
  }

  private setSvg(svg: SVGElement | null): void {
    if (!svg) return;
    const icon = svg.cloneNode(true) as SVGElement;
    const element = this.element.nativeElement;

    if (this.fontSize) {
      this.renderer.setAttribute(icon, 'width', this.fontSize.toString());
      this.renderer.setAttribute(icon, 'height', this.fontSize.toString());
    }

    element.innerHTML = '';
    this.renderer.appendChild(element, icon);

    this.cdr.markForCheck();
  }
}
